var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.285 26.292c.391-.39 1.036-.379 1.442.027l10.27 10.27 26.276-26.277c.406-.405 1.05-.417 1.442-.027.39.391.378 1.036-.027 1.442L16.731 38.683l-.037.036a.98.98 0 0 1-.697.276.98.98 0 0 1-.735-.312l-10.95-10.95c-.405-.405-.417-1.05-.027-1.44"
  })));
};
export default SvgCheckIcon;